<footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3"><h1 class="title">MEDABI •</h1></div>
        <div class="col-md-3">
          <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/home']"> Inicio </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/register']"> Registro </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/login']"> Login </a>
            </li>
          </ul>
        </div><!-- 
        <div class="col-md-3">
          <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/contact-us?ref=blkdsa-footer">
                Contact Us
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/about-us?ref=blkdsa-footer">
                About Us
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/blog?ref=blkdsa-footer">
                Blog
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://opensource.org/licenses/MIT">
                License
              </a>
            </li>
          </ul>
        </div>
        <div class="col-md-3">
          <h3 class="title">Follow us:</h3>
          <div class="btn-wrapper profile">
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple mr-1"
              href="https://twitter.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-twitter"> </i>
            </a>
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple mr-1"
              href="https://www.facebook.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-facebook-square"> </i>
            </a>
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple"
              href="https://dribbble.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-dribbble"> </i>
            </a>
          </div>
        </div> -->
      </div>
    </div>
</footer>